import { render, staticRenderFns } from "./FullDialog.vue?vue&type=template&id=ddf1fd1a&scoped=true&"
import script from "./FullDialog.vue?vue&type=script&lang=js&"
export * from "./FullDialog.vue?vue&type=script&lang=js&"
import style0 from "./FullDialog.vue?vue&type=style&index=0&id=ddf1fd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf1fd1a",
  null
  
)

component.options.__file = "FullDialog.vue"
export default component.exports